import type { MessageKey } from "./ru"

export const azMessages = {
  "common.loading": "Yüklənir...",
  "common.error": "Xəta",
  "common.back": "Geri",
  "common.next": "Növbəti",
  "common.search": "Axtarış",
  "auth.loginErrorTitle": "Giriş xətası",
  "auth.openViaTelegram": "Tətbiqi Telegram vasitəsilə açın",
  "auth.telegramRequired": "Tətbiq Telegram vasitəsilə açılmalıdır",
  "auth.authorizationError": "Avtorizasiya xətası",
  "device.rotatePortrait": "Cihazı şaquli vəziyyətə çevirin",
  "country.brazil": "Braziliya",
  "country.vietnam": "Vyetnam",
  "country.egypt": "Misir",
  "country.india": "Hindistan",
  "country.indonesia": "İndoneziya",
  "country.iran": "İran",
  "country.spain": "İspaniya",
  "country.italy": "İtaliya",
  "country.kazakhstan": "Qazaxıstan",
  "country.colombia": "Kolumbiya",
  "country.malaysia": "Malayziya",
  "country.mexico": "Meksika",
  "country.nigeria": "Nigeriya",
  "country.pakistan": "Pakistan",
  "country.russia": "Rusiya",
  "country.usa": "ABŞ",
  "country.turkey": "Türkiyə",
  "country.uzbekistan": "Özbəkistan",
  "country.ukraine": "Ukrayna",
  "country.philippines": "Filippin",
  "countrySelection.chooseCountry": "Ölkə seçin",
  "countrySelection.openAria": "Ölkə seçin",
  "languageSelection.chooseLanguage": "Dil seçin",
  "commercial.direction.autotrade": "Avto bazar",
  "commercial.direction.insurance": "Sığorta",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Yol yardımı",
  "commercial.searchLabel": "BeepApp axtarışı",
  "commercial.cityPlaceholder": "Şəhəri daxil edin",
  "commercial.emptyTitle": "Bu gün təklif yoxdur",
  "commercial.emptyLine1": "Şəhərinizdə hələ aktiv BeepApp tərəfdaşı yoxdur",
  "commercial.emptyLine2": "Biz artıq onları tapmaq və qoşmaq üzərində işləyirik",
  "commercial.emptyLine3": "Yeni təkliflər burada avtomatik görünəcək",
  "commercial.helperLine1": "Mövcud təklifləri görmək üçün",
  "commercial.helperLine2": "şəhərinizi daxil edin",
  "commercial.partnerPrompt": "BeepApp tərəfdaşı olmaq istəyirsiniz?",
  "commercial.apply": "Müraciət et",
  "main.admin": "Admin",
  "main.garage": "Qaraj",
  "main.signalSent": "Siqnal göndərildi",
  "main.partnerInviteUnavailable": "Tərəfdaş dəvəti əlçatan deyil",
  "main.enterPlate": "Dövlət nömrəsini daxil edin",
  "main.searchError": "Axtarış xətası",
  "main.signalSendError": "Siqnalı göndərmək alınmadı",
  "main.shareCardPrefix": "Nömrə kartı",
  "main.shareLinkError": "Keçidi hazırlamaq alınmadı",
  "main.searchByPlateAria": "Dövlət nömrəsi ilə axtarış",
  "main.russianPlateAria": "Rusiya dövlət nömrəsi",
  "main.plateAria": "Dövlət nömrəsi",
  "main.findPlateAria": "Nömrəni tap",
  "main.loadingVehicle": "Nömrə kartı yüklənir…",
  "main.leaveSignal": "Siqnal göndər",
  "main.share": "Paylaş",
  "signalSelection.chooseType": "Siqnal növünü seçin",
  "signalSelection.category.attention": "Şəxsi",
  "signalSelection.category.road": "Yol",
  "signalSelection.category.urgent": "Təcili",
  "signalSelection.chooseSignal": "Siqnal seçin",
  "signalSelection.suggestOwn": "Öz variantınızı təklif edin",
  "signalConfirmation.title": "Siqnalı təsdiqləyin",
  "signalConfirmation.plateHeading": "Dövlət nömrəsini yoxlayın",
  "signalConfirmation.signalHeading": "Seçilmiş siqnalı yoxlayın",
  "signalConfirmation.replyTitle": "Telegram-da cavaba icazə ver",
  "signalConfirmation.replyBody": "Bunu aktiv etsəniz, nömrə sahibi sizə\nTelegram-da yaza bilər. Cavab yalnız sizdə\n@username olduqda mümkündür. Cavab vermək qərarı\nnömrə sahibinə aiddir.",
  "signalConfirmation.consentText": "Bu siqnalın real vəziyyətə uyğun olduğunu\nvə spam və ya yalan məlumat olmadığını\ntəsdiqləyirəm.",
  "signalConfirmation.warning": "Göndərildikdən sonra siqnalı\ndəyişmək mümkün deyil",
  "signalConfirmation.sending": "Göndərilir…",
  "signalConfirmation.send": "Göndər",
  "partner.loadingAria": "Yüklənir",
  "partner.title": "Tərəfdaş proqramı",
  "partner.offerLine1": "BeepApp-a dəvət etdiyiniz istifadəçilərin bütün ödənişlərindən",
  "partner.offerLine2": "müddətsiz 30% qazanın",
  "partner.offerLine3": "Telegram Affiliate proqramı vasitəsilə",
  "partner.connectUnavailable": "Qoşulma Telegram Affiliate proqramı qurulduqdan sonra əlçatan olacaq.",
  "partner.connectTelegram": "Telegram-da qoşul",
  "partner.qrAria": "Tərəfdaş keçidinin QR kodu",
  "partner.download": "Yüklə",
  "partner.promoHeading": "Şəxsi promo kod yaradın",
  "partner.promoHelperLine1": "Promo kod əlavə bir abunə ili aktivləşdirir",
  "partner.promoHelperLine2": "və istifadəçi cəlb etməyə kömək edir",
  "partner.promoAria": "Promo kod",
  "partner.affiliateHeading": "Tərəfdaş keçidiniz",
  "partner.affiliateHelper": "Şəxsi QR kod yaratmaq üçün keçidi saxlayın",
  "partner.affiliateAria": "Tərəfdaş keçidi",
  "partner.qrNoteLine1": "QR kodu avtomobilinizdə,",
  "partner.qrNoteLine2": "sosial şəbəkələrdə və reklam materiallarında yerləşdirə bilərsiniz",
  "partner.save": "Saxla",
  "partner.reset": "Sıfırla",
  "partner.resetConfirm": "Saxlanmış tərəfdaş keçidi sıfırlansın? Promo kod sizdə qalacaq.",
  "partner.promoFormatError": "Promo kod 4–15 simvoldan ibarət olmalıdır.",
  "partner.affiliateHostError": "Yalnız t.me və ya telegram.me keçidlərinə icazə verilir.",
  "partner.affiliatePathError": "Keçiddə Telegram yolu yoxdur.",
  "partner.affiliateFormatError": "Yanlış tərəfdaş keçidi.",
  "partner.loadError": "Yükləmə xətası",
  "partner.checkInputError": "Daxil etdiyiniz məlumatları yoxlayın",
  "garageActivation.promoInvalid": "Promo kod etibarsızdır",
  "garageActivation.plateOccupied": "Bu dövlət nömrəsi artıq bağlıdır",
  "garageActivation.activateError": "Qarajı aktivləşdirmək alınmadı",
  "garageEntry.loadJournalError": "Jurnalı yükləmək alınmadı",
  "garageEntry.loadStatusesError": "Statusları yükləmək alınmadı",
  "garageEntry.activationSuccess": "Qaraj uğurla aktivləşdirildi",
  "garageEntry.plateAttached": "Nömrə bağlandı",
  "garageEntry.attachError": "Nömrəni bağlamaq alınmadı",
  "garageEntry.activationNote": "Qarajınızı aktivləşdirin",
  "garageSheet.activationTitle": "Qarajın aktivləşdirilməsi",
  "garageSheet.plateHelper": "Avtomobilin dövlət nömrəsini daxil edin",
  "garageSheet.promoHelper": "Promo kodunuz var?",
  "garageSheet.cleanBonusLine1": "Aktivləşdirmədən sonra 1 saat ərzində",
  "garageSheet.cleanBonusLine2": "“Təmiz başlanğıc” pulsuz olacaq",
  "garageSheet.activationFor": "Aktivləşdirmə müddəti",
  "garageSheet.cost": "Qiymət",
  "garageSheet.ownerConsentLine1": "Göstərilən dövlət nömrəli",
  "garageSheet.ownerConsentLine2": "avtomobilin sahibi olduğumu",
  "garageSheet.ownerConsentLine3": "təsdiqləyirəm.",
  "garageSheet.processing": "İşlənir...",
  "garageSheet.attach": "Bağla",
  "garageSheet.pay": "Ödə",
  "garageLifecycle.cleanTitle": "Təmiz başlanğıc",
  "garageLifecycle.deactivateTitle": "Qarajın deaktivləşdirilməsi",
  "garageLifecycle.cleanWarningLine1": "Nömrənin tarixçəsi silinəcək",
  "garageLifecycle.cleanWarningLine2": "və bərpa etmək mümkün olmayacaq!",
  "garageLifecycle.deactivateWarningLine1": "Deaktivləşdirmədən sonra aktiv",
  "garageLifecycle.deactivateWarningLine2": "Qaraj funksiyalarına giriş dayanacaq",
  "garageLifecycle.willBeDeleted": "SİLİNƏCƏK",
  "garageLifecycle.cleanRemovedLine1": "• Jurnaldakı bütün qeydlər",
  "garageLifecycle.cleanRemovedLine2": "• Alınmış siqnalların tarixçəsi",
  "garageLifecycle.cleanRemovedLine3": "• Nömrə kartındakı açıq",
  "garageLifecycle.cleanRemovedLine4": "  siqnal sayğacları",
  "garageLifecycle.willRemain": "QALACAQ",
  "garageLifecycle.cleanPreservedLine1": "• Nömrənin Qaraja bağlılığı",
  "garageLifecycle.cleanPreservedLine2": "• Qalan aktivləşdirmə müddəti",
  "garageLifecycle.cleanPreservedLine3": "• Seçilmiş nömrə statusu",
  "garageLifecycle.cleanPreservedLine4": "• Nömrə kartına ümumi baxış sayı",
  "garageLifecycle.freeFirstHour": "İlk saat ərzində pulsuz",
  "garageLifecycle.willBecomeUnavailable": "ƏLÇATMAZ OLACAQ",
  "garageLifecycle.deactivateRemovedLine1": "• Jurnal",
  "garageLifecycle.deactivateRemovedLine2": "• Nömrə statusunun seçilməsi və istifadəsi",
  "garageLifecycle.deactivateRemovedLine3": "• AutoClan-dan avtomatik çıxacaqsınız",
  "garageLifecycle.deactivateRemovedLine4": "• Avto bazar",
  "garageLifecycle.deactivateRemovedLine5": "• Sığorta",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Yol yardımı",
  "garageLifecycle.deactivateRemovedLine8": "• Dövlət nömrəsi Qarajdan ayrılacaq",
  "garageLifecycle.willRemainAvailable": "ƏLÇATAN QALACAQ",
  "garageLifecycle.deactivatePreservedLine1": "• Yoldaş",
  "garageLifecycle.deactivatePreservedLine2": "• Dispetçer",
  "garageLifecycle.deactivatePreservedLine3": "• Dövlət nömrəsi ilə axtarış və",
  "garageLifecycle.deactivatePreservedLine4": "  açıq avtomobil kartına baxış",
  "garageLifecycle.deactivatePreservedLine5": "• İstənilən vaxt Qarajı",
  "garageLifecycle.deactivatePreservedLine6": "  yenidən aktivləşdirmək imkanı",
  "garageLifecycle.cleanConsentLine1": "Bu nömrənin bütün tarixçəsinin",
  "garageLifecycle.cleanConsentLine2": "bərpa imkanı olmadan silinməsinə",
  "garageLifecycle.cleanConsentLine3": "razılıq verirəm.",
  "garageLifecycle.deactivateConsentLine1": "Deaktivləşdirməni və bütün aktiv",
  "garageLifecycle.deactivateConsentLine2": "Qaraj funksiyalarına girişin",
  "garageLifecycle.deactivateConsentLine3": "dayandırılmasını təsdiqləyirəm.",
  "garageLifecycle.clean": "Təmizlə",
  "garageLifecycle.deactivate": "Deaktiv et",
} satisfies Record<MessageKey, string>
